// 设置cookie
function setCookie(cname, cvalue, expiredDays) {
  let d = new Date()
  d.setTime(d.getTime() + (expiredDays * 24 * 60 * 60 * 1000))
  let expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}
// 获取cookie
function getCookie(cname) {
  let name = cname + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}
// 移除cookie
function removeCookie(cname) {
  let exp = new Date()
  exp.setTime(exp.getTime() - 1)
  let cvalue = getCookie(cname)
  if (cvalue != null) {
    document.cookie = cname + '=' + cvalue + ';expires=' + exp.toGMTString()
  }
}

var storeMode = 1 // 存储种类，0-cookie，1-localStorage，2-sessionStorage
const setStoreMode = (mode) => {
  storeMode = mode
}

const setStore = (name, content) => {
  if (!name) return false
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  try {
    if (storeMode === 0) { // cookie
      setCookie(name, content, 30)
    } else if (storeMode === 1) { // localStorage
      window.localStorage.setItem(name, content)
    } else {
      return false
    }
  } catch (oException) {
    if (oException.name === 'QuotaExceededError') {
      this.$message.warning('超出本地存储限额！')
    }
    return false
  }
  return true
}

const getStore = (name) => {
  if (!name) return null
  if (storeMode === 0) { // cookie
    return getCookie(name)
  } else if (storeMode === 1) { // localStorage
    return window.localStorage.getItem(name)
  } else {
    return null
  }
}

const removeStore = (name) => {
  if (!name) return
  if (storeMode === 0) { // cookie
    removeCookie(name)
  } else if (storeMode === 1) { // localStorage
    window.localStorage.removeItem(name)
  } else {
  }
}

const clearStore = () => {
  if (storeMode === 0) { // cookie
    document.cookie = ''
  } else if (storeMode === 1) { // localStorage
    window.localStorage.clear()
  } else {
  }
}

export {
  setStoreMode,
  setStore,
  getStore,
  removeStore,
  clearStore
}



// WEBPACK FOOTER //
// ./src/utils/storage.js